module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/4@2x_960287d89d8749508b21416c747a7ca9.png";